module.exports = __webpack_public_path__ + "img/covid-3-11-21-1-711x400.68a90613.jpg";